// src/redux/auth/authSelectors.js

// ✅ Login
export const selectUserData = (state) => state?.auth?.login?.data;
export const selectLoginLoading = (state) => state?.auth?.login?.loading;
export const selectLoginError = (state) => state?.auth?.login?.error;
export const selectAuthToken = (state) => state?.auth?.login?.token;

// ✅ Register
export const selectRegisterData = (state) => state?.auth?.register?.data;
export const selectRegisterLoading = (state) => state?.auth?.register?.loading;
export const selectRegisterError = (state) => state?.auth?.register?.error;

// ✅ Logout
export const selectLogoutData = (state) => state?.auth?.logout?.data;
export const selectLogoutLoading = (state) => state?.auth?.logout?.loading;
export const selectLogoutError = (state) => state?.auth?.logout?.error;

// ✅ Forgot Password
export const selectForgotPasswordData = (state) => state?.auth?.forgotPassword?.data;
export const selectForgotPasswordLoading = (state) => state?.auth?.forgotPassword?.loading;
export const selectForgotPasswordError = (state) => state?.auth?.forgotPassword?.error;

// ✅ Reset Password
export const selectResetPasswordData = (state) => state?.auth?.resetPassword?.data;
export const selectResetPasswordLoading = (state) => state?.auth?.resetPassword?.loading;
export const selectResetPasswordError = (state) => state?.auth?.resetPassword?.error;

// ✅ Verify Email
export const selectVerifyEmailData = (state) => state?.auth?.verifyEmail?.data;
export const selectVerifyEmailLoading = (state) => state?.auth?.verifyEmail?.loading;
export const selectVerifyEmailError = (state) => state?.auth?.verifyEmail?.error;

// ✅ Update Profile
export const selectUpdateProfileData = (state) => state?.auth?.updateProfile?.data;
export const selectUpdateProfileLoading = (state) => state?.auth?.updateProfile?.loading;
export const selectUpdateProfileError = (state) => state?.auth?.updateProfile?.error;

// ✅ Change Password
export const selectChangePasswordData = (state) => state?.auth?.changePassword?.data;
export const selectChangePasswordLoading = (state) => state?.auth?.changePassword?.loading;
export const selectChangePasswordError = (state) => state?.auth?.changePassword?.error;

// ✅ Refresh Token
export const selectRefreshTokenData = (state) => state?.auth?.refreshToken?.data;
export const selectRefreshTokenLoading = (state) => state?.auth?.refreshToken?.loading;
export const selectRefreshTokenError = (state) => state?.auth?.refreshToken?.error;

// ✅ General Auth State
export const selectAuthUser = (state) => state?.auth?.user?.data;
export const selectIsAuthenticated = (state) => state?.auth?.isAuthenticated;
export const selectAuthState = (state) => state?.auth;

// ✅ Role List
export const selectRoleListingData = (state) => state?.auth?.roleList?.data;
export const selectRoleListLoading = (state) => state?.auth?.roleList?.loading;
export const selectRoleListError = (state) => state?.auth?.roleList?.error;
